import statisticsActions from './actionTypes.js'
import http from '../../../services/http'

const actions = {
  [statisticsActions.FETCH_STATISTICS]: async ({ dispatch }, { studyId, query }) => {
    const response = await http.post(`/statistics/${studyId}/`, { query: query })
    return response
  }
}

export default {
  ...actions
}
